// extracted by mini-css-extract-plugin
export default {"teamsPage":"TeamsPageOverride_teamsPage__WjZfT","teamsBlock":"TeamsPageOverride_teamsBlock__UFeNK"};